module.exports = __webpack_public_path__ + "static/media/icon-quality-green.baf2e392.svg";